import { render } from "./ToolbarComp.vue?vue&type=template&id=131d369e&scoped=true"
import script from "./ToolbarComp.vue?vue&type=script&lang=js"
export * from "./ToolbarComp.vue?vue&type=script&lang=js"

import "./ToolbarComp.vue?vue&type=style&index=0&id=131d369e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131d369e"]])

export default __exports__